















import Vue from 'vue';
import Component from 'vue-class-component';
import DatesForm from '@/components/DatesForm.vue';

interface DateRequest {
	end_date: string;
	fpp: number;
	location: string;
	promo_code: string;
	start_date: string;
	source: string;
}

const Setup = Vue.extend({
	name: 'DatesWidget',
	components: {
		DatesForm,
	},
	props: {
		buttonLabel: String,
		checkInLabel: String,
		checkoutLabel: String,
		classes: [Array, Object, String],
		locationLabel: String,
		promoLabel: String,
		showPromo: String,
		title: {
			type: String,
			default: 'Reservations',
		},
	},
});

@Component
export default class DatesWidget extends Setup {
	// Props
	public buttonLabel!: string;
	public checkInLabel!: string;
	public checkoutLabel!: string;
	public classes!: any;
	public locationLabel!: string;
	public promoLabel!: string;
	public showPromo!: string;

	public get paths(): App.Paths {
		return this.$store.state.paths;
	}

	public handleSubmittedDates(data: DateRequest) {
		const params = {
			start_date: data.start_date,
			end_date: data.end_date,
			promo: data.promo_code,
			loc: data.location,
			ffp: data.fpp,
		} as { [key: string]: string|number };

		const form = document.createElement('form');
		form.setAttribute('method', 'POST');
		form.setAttribute('action', this.paths.reservationBook);

		Object.keys(params).forEach((key: string) => {
			const input = document.createElement('input');
			const value = String(params[key] || '');
			input.setAttribute('type', 'hidden');
			input.setAttribute('name', key);
			input.value = value;

			form.appendChild(input);
		});

		document.body.appendChild(form);

		form.submit();
	}
}
